export default __webpack_public_path__ + "static/media/HotelPic.bac75c5c.jpg";